import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { getAuthorResearchPerfEvalOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

export const Route = createFileRoute('/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather')({
  component: RouteComponent,
  loaderDeps: ({ search: { userId } }) => ({ userId }),
  loader: async ({ context: { queryClient }, params: { evaluationId }, deps: { userId } }) => {
    if (userId == null) {
      return null;
    }

    const data = await queryClient.ensureQueryData(getAuthorResearchPerfEvalOptions(evaluationId, userId));

    if (data == null) {
      throw redirect({ to: '/research-perf-eval/$evaluationId', params: { evaluationId }, search: true });
    }

    return data;
  },
});

function RouteComponent() {
  return <Outlet />;
}
